export default {"src":"/_next/static/image/public/images/ic_homecare_menu.f9fd26b4777f2fca1cd7bc15296c61a7.svg","height":47,"width":47};